import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1607e2b8")

_pushScopeId("data-v-1607e2b8")
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "dialog-body" }
const _hoisted_3 = { class: "field old-pass" }
const _hoisted_4 = { class: "field new-pass" }
const _hoisted_5 = { class: "field confirm-pass" }
const _hoisted_6 = { class: "error" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "change-pass-view-root",
    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.OnClickClose()), ["self"]))
  }, [
    _createVNode("div", {
      class: ["content", { desktop: !_ctx.isMobile }],
      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", null, _toDisplayString(_ctx.iN('setting.changepassword')), 1),
        _createVNode("span", {
          class: "icon-close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.OnClickClose()))
        })
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", null, _toDisplayString(_ctx.iN('changepassword.oldpassword')), 1),
          _withDirectives(_createVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.oldPass = $event))
          }, null, 512), [
            [_vModelText, _ctx.oldPass]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("span", null, _toDisplayString(_ctx.iN('changepassword.newpassword')), 1),
          _withDirectives(_createVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newPass = $event))
          }, null, 512), [
            [_vModelText, _ctx.newPass]
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.iN('changepassword.confirmpassword')), 1),
          _withDirectives(_createVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmPass = $event))
          }, null, 512), [
            [_vModelText, _ctx.confirmPass]
          ])
        ]),
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1),
        _createVNode("div", {
          class: "btn",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.OnCLickConfirm && _ctx.OnCLickConfirm(...args)))
        }, _toDisplayString(_ctx.iN('common.confirm')), 1)
      ])
    ], 2)
  ]))
})